import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getProcessInsatnces(queryString, filterVariables) {
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + "/processesAPI/getAllProcessList?" + queryString,filterVariables,{
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching instances"
                    });
                }
            });
    },
    terminateProcessInstance(procInstId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/processesAPI/delete/" + procInstId)
            .then(response => {
                return response.data;
            });
    },
    getFilterDropdownData() {
        return axios.get(constants.BASE_URL + "/process-engine/processes/filter-dropdown-data", {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    getInstanceDetails(instId, menu) {
        axios.defaults.withCredentials = true;
        return axios.get(menu == "all" ? constants.BASE_URL + "/process-engine/processes/" + instId : constants.BASE_URL + "/processesAPI/" + instId)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
    },
    exportAsPDF(processInstanceId, menu) {
        let queryStr = constants.BASE_URL + "/process-engine/processes/export/" + processInstanceId + "/" + menu;
        const link = document.createElement('a');
        link.href = queryStr;
        link.click();
    },
    getProcessErrorsForInstance(queryString) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/process-errors/process-instance-failure-data?" + queryString, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching process errors"
                    });
                }
            });
    },
    getAllTasks(input, menu, filterVariables) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(menu == "all" ? constants.BASE_URL + "/process-engine/tasks/all-tasks?" + input : constants.BASE_URL + "/tasks-api/all?" + input, filterVariables,{
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching tasks"
                });
            }
        });
    },
    getActivities(procInstId) {
        return axios.get(constants.BASE_URL + "/activities/process-instances/" + procInstId, {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
}
